<div id="about" >
    <div class="container">
        <div class="row">
            <div class="col-12 mb-2">
                <button type="button" class="aboutClose close" (click)="backClicked()">
                    <svg-image   color="#000000" name="Icon-icon-close" [width]="24" [height]="24"></svg-image>
                     </button>
            </div>
            <div class="col-12 m-auto">
                  <div>
                    <div id="scottRando-main">
                        <img src="{{globalService.externalResourcesUrl}}{{(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorPhotoFileName}}" class="img-fluid about-image" width="100%">
             
                        <h2>{{(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorName}}</h2>
                        <div class="orangeCoun">{{(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.name}} Tax Collector</div>

                        <div [innerHTML]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorBio"></div>
                     </div>
                    <!-- <iframe url="{{https://www.google.com/maps/d/u/0/embed?mid=1Och1eYHJxJrvxqMyhIPT59mePgre4gYI&ll=28.540093252585322%2C-81.3774634061956&z=14}}"></iframe>
                             -->
                    <iframe width="100%" height="500px" id="payment-iframe"
                        [src]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorMapLink | safe">
                    </iframe>
                      <div class="col-12 row mt-4 mb-4 about-info">

                         <div class="col-4 text-center">
                             <div class="col-12 about-info-bg">
                                <div class="about-info-icon">
                                    <img src="{{globalService.staticResourceURL}}assets/images/Icon-about-website.svg" class="img-fluid">
                                 </div>
                                 <div class="about-info-title">Website</div>
                                 <div class="about-info-subtitle" [innerHTML]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorURL"></div>
                                 <!-- <a class="about-info-subtitle" style="display:block" target="_blank" href="{{(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorURL}}">{{taxCollectorURL}}</a> -->
                            </div>
                         </div> 
                          
                         <div class="col-4 text-center">
                              <div class="col-12 about-info-bg">
                                 <div class="about-info-icon">
                                    <img src="{{globalService.staticResourceURL}}assets/images/Icon-about-phone.svg" class="img-fluid">
                                 </div>
                                 <div class="about-info-title">Phone</div>
                                 <div class="about-info-subtitle" [innerHTML]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorPhoneNumber"></div>
                             </div>
                          </div>
                            
                         <div class="col-4 text-center">
                              <div class="col-12 about-info-bg">
                                 <div class="about-info-icon">
                                    <img src="{{globalService.staticResourceURL}}assets/images/Icon-about-email.svg" class="img-fluid">
                                 </div>
                                 <div class="about-info-title">Email</div>
                                 <div class="about-info-subtitle" [innerHTML]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorEmailAddress"></div>
                                
                             </div>
                          </div>
                     </div> 
                    
                    <div id="add-info">
                        <div [innerHTML]="(dmvStoreService?.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorAdditionalInfo"></div>
                        
                        <div class="m-auto">
                            <a class="m-5">
                                <button class="btn btn-primary btn-commonbtn m-auto" (click)="backClicked()">Close </button>
                            </a>
                        </div>              
                        
                     </div>
                </div>
            </div>            
        </div>        
    </div>
    
    
</div>